export function sortRows(rows, colunas, sortCol, sortDir) {
  if (!sortCol) return rows
  const col = colunas.find(c => c.key === sortCol)
  if (!col) return rows
  const sorted = [...rows]
  sorted.sort((a, b) => {
    let va = col.get(a), vb = col.get(b)
    if (col.numeric) {
      va = va ?? -1; vb = vb ?? -1
    } else if (col.date) {
      va = va ? new Date(va).getTime() : 0; vb = vb ? new Date(vb).getTime() : 0
    } else {
      va = String(va ?? '').toLowerCase(); vb = String(vb ?? '').toLowerCase()
    }
    if (va < vb) return sortDir === 'asc' ? -1 : 1
    if (va > vb) return sortDir === 'asc' ? 1 : -1
    return 0
  })
  return sorted
}

export default function SortableTh({ colKey, sortCol, sortDir, onSort, children }) {
  // Titulo com '\n' quebra em duas linhas (economiza espaco horizontal na coluna);
  // demais colunas continuam em uma linha so, sem mudar de comportamento.
  const duasLinhas = typeof children === 'string' && children.includes('\n')
  return (
    <th onClick={() => onSort(colKey)} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: duasLinhas ? 'pre-line' : 'nowrap', lineHeight: duasLinhas ? 1.25 : undefined, textAlign: 'center' }}>
      {children}{' '}
      <span style={{ fontSize: 9, opacity: sortCol === colKey ? 1 : 0.35 }}>
        {sortCol === colKey ? (sortDir === 'asc' ? '▲' : '▼') : '⇅'}
      </span>
    </th>
  )
}
